import { render, staticRenderFns } from "./WebsiteTermsAndCondition.vue?vue&type=template&id=b43b7902&"
import script from "./WebsiteTermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./WebsiteTermsAndCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports